import { Form, Formik } from 'formik'
import CallInputs from './call_inputs'
import { getInitialValues, getValidationSchema } from './utils/util'
import { Col, Row } from '../ui/layout'
import PasswordHelper from '../password_helper'

const FormFactory = ({ data, onSubmit, children }: any) => {
  const validationSchema = getValidationSchema(data)
  const initialValues = getInitialValues(data)

  const options = {
    enableReinitialize: true,
    initialValues,
    onSubmit
  }

  if (validationSchema) Object.assign(options, { validationSchema })

  return (
    <Formik {...options}>
      {(actions) => (
        <Form>
          {children || data.map(({ name, component: Component, items }: any, idx: any) => (
            <div key={idx}>
              <Row>
                {items.filter((item: any) => item.component).map(({ col, ...item }: any, index: any) => (
                  <Col w={col || '100%'} key={`${idx}-${index}`} mb={item.mb || 15} mt={item.mt}>
                    <CallInputs {...item} {...actions} />
                    {item.hasPasswordHelp && <PasswordHelper color='#000' />}
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </Form>
      )}
    </Formik>
  )
}

export default FormFactory
